"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactIntl = require("react-intl");

var _default = (0, _reactIntl.defineMessages)({
  placeholder: {
    id: 'xsui.tree-select.placeholder',
    defaultMessage: 'Select'
  },
  selectedItems: {
    id: 'xsui.tree-select.selected-items',
    defaultMessage: '{count} items selected'
  },
  selectAll: {
    id: 'xsui.tree-select.select-all',
    defaultMessage: 'Select all'
  },
  unselectAll: {
    id: 'xsui.tree-select.unselect-all',
    defaultMessage: 'Unselect all'
  }
});

exports["default"] = _default;